module.exports = __webpack_public_path__ + "img/JacketBG@2x.e4bfadd2.png";